module.exports = __webpack_public_path__ + "static/img/nengyuan.55e1068.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/market/nengyuan.png
// module id = b7XU
// module chunks = 2